module.exports = __webpack_public_path__ + "img/login.a4a74e4b.png";